import script from "./ColorInputVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorInputVue.vue?vue&type=script&setup=true&lang=js"

import "./ColorInputVue.vue?vue&type=style&index=0&id=e70c6c0c&lang=scss&scoped=true"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e70c6c0c"]])

export default __exports__